import script from "./MegaMenuResources.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaMenuResources.vue?vue&type=script&setup=true&lang=js"

import "./MegaMenuResources.vue?vue&type=style&index=0&id=9ac2a750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ac2a750"]])

export default __exports__